const capitalizeWords = (words: string) =>
  // The "/\b\w/g" regex matches the first letter of each word separated by spaces
  words.replace(/\b\w/g, match => match.toUpperCase());

export default capitalizeWords;
